import { SET_GENERAL_DATA } from './types'
import { pageData } from 'src/services/ContentApi'

export const general = (lang) => async (dispatch) => {
  try {
    const generalSettingsData = await pageData('generalsettings', lang)
    dispatch({ type: SET_GENERAL_DATA, payload: generalSettingsData })
  } catch (error) {
    throw error
  }
}
